<template>
  <div style="position: relative">
    <div
      class="estilo-texto"
      v-text="texto"
      :class="[
        bold ? 'bold-text' : '',
        error ? 'error' : '',
        success ? 'success' : '',
      ]"
    ></div>
    <div
      class="estilo-linea"
      :class="[error ? 'error-linea' : '', success ? 'success-linea' : '']"
    ></div>
  </div>
</template>

<script>
export default {
  props: {
    texto: { Type: String, default: "Texto por defecto" }, // Texto que se mostrara en
    bold: Boolean, // Convierte el texto en bold
    error: Boolean, // Error de validación, el texto de muestra en rojo cuando este es true
    success: Boolean, // Todo OK! en la validación, el texto de muestra en verde cuando este es true
  },
};
</script>

<style>
.estilo-texto {
  position: relative;
  margin-left: 45px;
  z-index: 1;
  background: #ffffff;
  width: fit-content;
  padding: 0 10px;
  font-size: 13px !important;
  font-weight: 400;
  letter-spacing: 1.5px;
  color: #5e5d5d;
}

.estilo-linea {
  position: absolute;
  width: 100%;
  /* height: 1.4px !important; */
  height: 2px !important;
  background: #7f7f7f;
  top: 12px;
}

.bold-text {
  font-weight: bold !important;
}

.error {
  color: #c41111 !important;
}

.success {
  color: #0dae3b !important;
}

.error-linea {
  background: #c41111 !important;
}

.success-linea {
  background: #0dae3b !important;
}
</style>
